<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      clipped
      :expand-on-hover="this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.xl"
      color="#EF6C00"      
      app     
      transition="fade-transition"      
      v-if="usuarioLogado"
    >
      <v-list dense v-if="companyobj.logoUrl" class="py-3" style="background-color:white;padding: 7px;">
        <v-img :src="companyobj.logoUrl" max-width="-webkit-fill-available;"></v-img>
      </v-list>

      <v-list dense  class="py-0" >
        <v-list-item  to='/home' @click="textoMenu = 'Dashboard'" active-class="corMenu" >
          <v-list-item-action>
            <v-icon dense medium color="white">dashboard</v-icon>
            <!-- <img src="../assets/icon-painel-nacional.png"> -->
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Dashboard</v-list-item-title> 
            <!-- <br> -->           
          </v-list-item-content>
        </v-list-item>    

        <v-list-item to="/empresas" v-if="user.tipo == 'ADMIN'" active-class="corMenu">
          <v-list-item-action>
            <v-icon dense medium color="white">domain</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Empresas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/categorias"  active-class="corMenu">
          <v-list-item-action>
            <v-icon dense medium color="white">category</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Categorias</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/produtos"  active-class="corMenu">
            <v-list-item-action>
              <v-icon dense medium color="white">fastfood</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title style="color:white;word-wrap: break-word;">Produtos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        <v-list-item to="/pedidos" active-class="corMenu">
          <v-list-item-action>
            <v-icon dense medium color="white">money</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Pedidos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <hr>
        <v-list-item   active-class="corMenu" @click="textoMenu = 'Suporte'">
          <v-list-item-action>
            <img src="../assets/icon-suporte-fechado.png">
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Suporte</v-list-item-title>            
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-navigation-drawer>

    <v-app-bar
      app
      clipped-left
      v-if="usuarioLogado"
      color="#E65100" height="60"
    >
      <v-app-bar-nav-icon  @click.stop="drawer = !drawer" style="color:white;"></v-app-bar-nav-icon>
      <!-- <p class="textomenu" v-if="this.$vuetify.breakpoint.lg">{{textoMenu}}</p> -->
      <!-- <img v-if="this.$vuetify.breakpoint.lg" src="../assets/logo.png" alt="" height="50" width="auto" class="imagemLogo"> -->
      
      <v-spacer></v-spacer>

      <!-- MENU USUÁRIO -->    
      <v-menu bottom offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon  dark v-on="on">
            <v-avatar size="40">
              <v-img v-if="companyobj.logoUrl != ''"  :src="companyobj.logoUrl"></v-img>
              <v-icon v-else large dark>account_circle</v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item >
            <v-list-item-avatar>
              <v-img v-if="companyobj.logoUrl != ''" :src="companyobj.logoUrl"></v-img>
              <v-icon v-else large light>account_circle</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title style="font-weight: bold;color: grey;">{{user.nome}}</v-list-item-title>
              <v-list-item-subtitle>{{companyobj.nome}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>
      
          <v-list-item  @click.stop="teste()">
              <v-list-item-title>Editar usuário</v-list-item-title>
          </v-list-item>
          <v-list-item @click.stop="teste()">
              <v-list-item-title>Alterar senha</v-list-item-title>
          </v-list-item>
          <v-list-item @click.stop="teste()">
              <v-list-item-title>Enviar sugestão</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item @click="Sair()">
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>      
    </v-app-bar>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: {
      source: String,
    },
    data() {
      return {
        company: [],
        /* user: [], */
        textoMenu: 'Dashboard',
        drawer: null,
        items: [
          { title: 'Home', icon: 'dashboard' },
          { title: 'About', icon: 'question_answer' },
        ],
        clipped: true,
        mini: false,
        right: null,
        title: 'Controle de Clientes',
      }
    },

    created () {
      //this.$vuetify.theme.dark = false
    },

    mounted: function () { 
      if(sessionStorage.getItem('accToken') != null)                    
        this.$store.dispatch('Logar', this.token)
      if(sessionStorage.getItem('user') != null)
        this.$store.dispatch('SetUser')
      if(sessionStorage.getItem('company') != null)
        this.$store.dispatch('SetCompany')
    },

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj
    }),

    methods:{
      Sair(){
        this.$store.dispatch('Sair')
        this.$router.push({ path: '/login' })
      },

      menuListaCli(){
        this.$router.push({ path: '/lista' })
      },

      menuListaAtend(){
        this.$router.push({ path: '/tipoatend' })
      },

      menuSair(){
        this.$router.push({ path: '/' })
      },

      menuPainels(){
        this.$router.push({ path: '/paineis' })
      },
    }
  }
</script>

<style>
  .v-navigation-drawer{
    width: 60px
  }

  .v-navigation-drawer .v-list .v-list__tile {
    text-decoration: none;
    color: white;
    height: 100%;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  .v-divider{
  margin-top: 0%;
  margin-bottom: 0%;
  }

  .corMenu{
    background-color: #EF6C00!important;
    border-color: #EF6C00 !important;
  }

  .imagemLogo{
    position:absolute;
    right:50%;
    left:50%;
    margin-right:-50px;
    margin-left:-50px;
  }
  
  .textomenu{
    font-size: 15px;
    position:absolute;
    left:5%;
    color: white;
    /* margin-right:-50px; */
    margin-left:-20px;
  }
  
  hr {
    border: 0;
    width: 100%;
    height: 1px;
    background-image: linear-gradient(to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.75),
      rgba(255, 255, 255, 0));
  }

  .titulosmenu{
    font-weight: bold;
    color: grey;
  }
</style>
